module.exports = __webpack_public_path__ + "static/media/CREDIT_CARD.626d12a5.png";